import * as ACTION from './constants';
import { arrayMerge } from '../../utils';

const initialState = {
  error: null,
  programs: [],
  draftPrograms: [],
  wellnessPrograms: [],
  filters: [],
  isLoading: false,
  isFilterLoading: false,
  isUpdating: false,
  query: '',
  totalCount: null
};

const programTypeMap = {
  'standard': 'programs',
  'drafts': 'draftPrograms',
  'wellness': 'wellnessPrograms'
};

export default function reducers(state = initialState, action) {
  switch(action.type) {
    case ACTION.PROGRAM_BASE:
      return {...initialState};
    case ACTION.PROGRAM_QUERY:
      return {...initialState,
        error: null,
        isLoading: true,
        isUpdating: false,
      };
    case ACTION.LIBRARY_LOADING:
      return {...state,
        error: null,
        isLoading: true,
        isUpdating: false,
      };
    case ACTION.LIBRARY_LOADED:
      const programKey = programTypeMap[action.programType];
      return {...state,
        error: null,
        isLoading: false,
        isUpdating: false,
        [programKey]: arrayMerge(state[programKey], action.programs, action.specialType),
        totalCount: action.totalCount,
        query: action.query
      };
    case ACTION.FILTER_LOADING:
      return {...state,
        isFilterLoading: true
      };
    case ACTION.FILTER_LOADED:
      return {...state,
        isFilterLoading: false,
        filters: action.filters
      };
    case ACTION.PROGRAM_UPDATING:
      return {...state,
        error: null,
        isUpdatiing: true,
      };
    case ACTION.PROGRAM_ERROR:
      return {...state,
        error: action.error,
        isLoading: false,
        isUpdating: false,
      };
    default:
      return state;
  }
}
